import { normalizeTagValue } from '~/utils/route'

export const useTagArticlePage = async (options?: { tagLabel?: string }) => {
  const route = useRoute()
  const { $i18n } = useNuxtApp()
  const { getPath, slugPageInfo } = useNavigationMenu()

  const tagLabel = options?.tagLabel || 'Tags'
  const normalizedRouteTag = computed(() => normalizeTagValue(String(route.params.slugTag || '')))

  const tag = ref<ArticleTag | null>(null)
  const {
    asyncCategory,
    breadcrumbs,
    items: articles,
    page,
    perPage,
    total,
  } = await useListApi<Article>({
    itemPath: `/articles/tag/${normalizedRouteTag.value}`,
    componentName: 'TagArticle',
    hasCategory: false,
    defaultPerPage: 24,
    onFetchSuccess (response) {
      tag.value = response?._data?.meta?.tag
    },
  })

  // Use tag title from API response, fallback to route param if not available
  const section = computed(() => ({
    title: `${tagLabel} ${tag.value?.title || normalizedRouteTag.value}`,
    description: `${$i18n.t('global.sum')}${slugPageInfo.value?.title} ${tagLabel} ${tag.value?.title || normalizedRouteTag.value} ${slugPageInfo.value?.metaDescriptionFront}`,
  }))

  const modifiedBreadcrumbs = computed(() => {
    // Ensure parent breadcrumb items have paths
    const items = breadcrumbs.value.map((item, index) => {
      // If last item in original breadcrumbs doesn't have path, add it
      if (index === breadcrumbs.value.length - 1 && !item.path) {
        return {
          ...item,
          path: getPath({ componentName: 'Article' }),
        }
      }
      return item
    })
    // Add current page (no path = current page)
    items.push({ title: section.value?.title })
    return items
  })

  const { analyticEvent, fbPixelEvent } = useAnalytic()
  const eventArticleTag = (title: string) => {
    analyticEvent({
      ga4ActionName: 'click_blog_tag_list',
      ga4Label: title,
    })
    fbPixelEvent({
      fbCategory: 'trackCustom',
      fbEvent: 'Blog - Tage List',
      fbValue: { label: title },
    })
  }

  useCustomSeo({
    title: () => section.value.title,
    description: () => section.value.description,
  })

  return {
    tag,
    section,
    breadcrumbs,
    asyncCategory,
    modifiedBreadcrumbs,
    articles,
    page,
    perPage,
    total,
    getPath,
    eventArticleTag,
  }
}
